import { reserve } from "./reserve";
import { read } from "./read";

export const ReservationsEndpoint = {
  reserve,
  read,
};
